import { useMemo } from 'react';
import { useLocation } from '@reach/router';
import { useBreadcrumbsMap } from 'staticQueries/breadcrumbs-map';
import { getBreadcrumbs } from './helpers';

export const useBreadcrumbs = () => {
  const { pathname } = useLocation();
  const { map: breadcrumbsMap, validPages } = useBreadcrumbsMap();

  return useMemo(
    () => getBreadcrumbs(pathname, breadcrumbsMap, validPages),
    [breadcrumbsMap, validPages, pathname],
  );
};
